/*!
 * textHash.js — a short fingerprint of a text, the same in the browser and the server
 * © 2026 Rob Canning — GPLv3
 *
 * The live console says, writing its file, which text of it it last saw
 * (liveProject.js); the server, finding the file says something else, keeps
 * that first (server.js). FNV-1a over the text's UTF-16 code units: no
 * crypto, nothing to wait for (a page going sends its last write at once).
 */

export function textHash(text) {
  let h = 0x811c9dc5;
  const s = String(text ?? "");
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, "0");
}
